import React from 'react';

// Compact segmented progress bar summarising a project's content items:
// green = live (available), amber = in build, slate = retired.
export const ProjectStatusBar = ({ rollup, testId }) => {
  const r = rollup || { total: 0, live: 0, in_build: 0, retired: 0 };
  const total = r.total || 0;
  if (total === 0) {
    return <span className="text-xs text-muted-foreground" data-testid={testId}>No items</span>;
  }
  const pct = (n) => `${(n / total) * 100}%`;
  return (
    <div className="min-w-[120px]" data-testid={testId} title={`${r.live} live · ${r.in_build} in build · ${r.retired} retired`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] font-medium text-emerald-700">{r.live}/{total} live</span>
        {r.in_build > 0 && <span className="text-[10px] text-amber-600">{r.in_build} building</span>}
      </div>
      <div className="flex h-1.5 w-full overflow-hidden rounded-full bg-muted">
        {r.live > 0 && <div className="bg-emerald-500" style={{ width: pct(r.live) }} data-testid={testId ? `${testId}-live` : undefined} />}
        {r.in_build > 0 && <div className="bg-amber-400" style={{ width: pct(r.in_build) }} />}
        {r.retired > 0 && <div className="bg-slate-400" style={{ width: pct(r.retired) }} />}
      </div>
    </div>
  );
};

export default ProjectStatusBar;
